import React from "react";
import { Droppable, Draggable } from "react-beautiful-dnd";
import { Col, Row } from "reactstrap";
/* import { renderElement } from "../../../../helpers/renderElement"; */
import { connect } from "react-redux";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import { sourceTypes } from "../../../../../constants/cms/sourceType";
import "../styles/TemplateContent.css";

class TemplateFooter extends React.Component {
  state = {
    isDropZoneDisabled: false,
  };
  componentDidMount() {
    if (this.props.cms.enviroment !== sourceTypes.TEMPLATE) {
      this.disableDropZone(true);
    }
  }
  disableDropZone = (isDisabled) => {
    this.setState({ isDropZoneDisabled: isDisabled });
  };
  onSelect = (el) => {
    const { dispatch, cms } = this.props;
    if (!cms.editMode) {
      return;
    }
    dispatch(templateActions.select(el));
  };

  onDelete = (el) => {
    const { dispatch } = this.props;
    dispatch(templateActions.remove(el, "FOOTER"));
  };
  sortChildrens = () => {
    const { template } = this.props.template;

    const dataSource =
      template && template.content
        ? Array.from(
            template.content.footer.content
              .sort((a, b) => {
                let x = a.sortOrder;
                let y = b.sortOrder;
                return y < x ? 1 : y > x ? -1 : 0;
              })
              .filter((el) => el.parentId === null)
          )
        : [];

    return dataSource;
  };
  render() {
    const { template, selectedContainer, selectedElement } = this.props.template;
    const { editMode, enviroment } = this.props.cms;

    if (template === undefined) return null;
    if (!editMode && enviroment !== sourceTypes.TEMPLATE) {
      return (
        <div>
          {this.sortChildrens().map((el, index) => {
            return (
              <div className="animated fadeIn" key={index}>
                <div className="element-container">
                  <Row
                    style={{
                      width: "100%",
                      display: "inline-flex",
                      marginLeft: "0px",
                    }}
                  >
                    <Col
                      style={{
                        width: "100%",
                        display: "inline-flex",
                        padding: "0px",
                      }}
                    >
                      <Col
                        style={{
                          maxWidth: "100%",
                          padding: "0px",
                        }}
                      >
    {/*                     {renderElement(el.type, el, this.disableDropZone)} */}
                      </Col>
                    </Col>
                  </Row>
                </div>
              </div>
            );
          })}
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    alert: state.alert,
    template: state.template,
    cms: state.cms,
    form: state.form,
  };
}
export default connect(mapStateToProps)(TemplateFooter);
